module.exports = __webpack_public_path__ + "static/media/petmatsafearea.c6bd3cdc.svg";